import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets.v2/images/logo-sign-up.svg'


const _hoisted_1 = { class: "sign-up pop-up" }
const _hoisted_2 = { class: "sign-up__inner" }
const _hoisted_3 = { class: "sign-up__form-box" }
const _hoisted_4 = {
  key: 0,
  class: "shortform-sign-up"
}
const _hoisted_5 = { class: "shortform-sign-up__group" }
const _hoisted_6 = {
  key: 1,
  class: "shortform-sign-up"
}
const _hoisted_7 = {
  key: 2,
  class: "shortform-sign-up"
}

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { PasswordResetView } from '@/models/auth/models'
import { authCssFix } from '@/helpers/html'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const route = useRoute()

const view = ref(new PasswordResetView())

onMounted(async () => {
  const token = route.query.reset_token
  await view.value.initResetToken(token as string)

  authCssFix()
})

async function submitForm(): Promise<void> {
  view.value.submitForm()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sign-up__content" }, [
        _createElementVNode("div", { class: "sign-up__logo-text-box" }, [
          _createElementVNode("a", {
            class: "sign-up__logo",
            href: "/"
          }, [
            _createElementVNode("img", {
              class: "sign-up__logo-img",
              src: _imports_0,
              alt: "Shortform"
            })
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (view.value.state === 'form')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "shortform-sign-up__title" }, "Reset Your Password", -1)),
              _createElementVNode("p", null, [
                _cache[1] || (_cache[1] = _createTextVNode(" Enter a new password for your ", -1)),
                _createElementVNode("b", null, _toDisplayString(view.value.email), 1),
                _cache[2] || (_cache[2] = _createTextVNode(" account below. ", -1))
              ]),
              _createElementVNode("form", {
                role: "form",
                class: "shortform-sign-up__form",
                novalidate: "",
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", {
                    class: "shortform-sign-up__label",
                    for: "reset_password"
                  }, "New Password", -1)),
                  _createVNode(InputWithContextMenu, {
                    id: "reset_password",
                    modelValue: view.value.model.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((view.value.model.password) = $event)),
                    class: _normalizeClass(["shortform-sign-up__input", view.value.validation.stateClass('password')]),
                    placeholder: "",
                    type: "password",
                    autocomplete: "current-password",
                    autofocus: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(FormError, {
                    errors: view.value.validation.errors,
                    field: "password"
                  }, null, 8, ["errors"]),
                  _createVNode(FormError, {
                    errors: view.value.validation.errors,
                    field: "reset_token"
                  }, null, 8, ["errors"])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "shortform-sign-up__group" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "shortform-sign-up__submit button button--theme"
                  }, " Set a new password ")
                ], -1))
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (view.value.state === 'notoken')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("p", null, "Please use the link from the email to reset the password.", -1)
            ]))]))
          : _createCommentVNode("", true),
        (view.value.state === 'success')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("p", null, " You've successfully changed your password and we've logged you in! ", -1)),
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'discover' },
                  style: {"color":"#ffb600"}
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("strong", null, "Go to Shortform", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})